import { ui } from '../copy/ui';
import { CopyButton } from './CopyButton';
import { cx } from './cx';
import { Mono } from './Mono';
import s from './RequestId.module.css';

/**
 * The label's colour. `subtle` is the label treatment everywhere else; `muted` is for a
 * ground that may be sunken, where --text-subtle is 4.12:1 in the light theme.
 */
export type RequestIdTone = 'subtle' | 'muted';

export interface RequestIdProps {
  id: string;
  /** Names which request this is. Uppercased by the label treatment, so write it in prose. */
  label?: string;
  tone?: RequestIdTone;
}

export function RequestId({ id, label = ui.requestId, tone = 'subtle' }: RequestIdProps) {
  return (
    <div className={s.wrap}>
      <span className={cx(s.label, tone === 'muted' && s.muted)}>{label}</span>
      <div className={s.row}>
        <Mono>{id}</Mono>
        <CopyButton value={id} label={ui.copyRequestId} />
      </div>
    </div>
  );
}

export default RequestId;
